module.exports = __webpack_public_path__ + "static/media/heart.508ade00.svg";